import React from 'react';
import { useTranslation } from 'react-i18next';

import { GTM_EVENTS } from 'src/shared/constants';
import { gtmUtils } from 'src/shared/toolbox';

import styles from './WhatsappFloatButton.module.scss';

// FIXME: ReactComponent import causes test issues, so we maintain the SVG inline
// but ensure it stays synchronized with the assets file src/assets/images/whatsapp.svg
const WhatsappIcon = () => (
	<svg width="50" height="50" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
		<path d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01zM12.04 20.15c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43-.14-.01-.3-.01-.46-.01a.87.87 0 0 0-.64.3c-.22.25-.85.83-.85 2.02 0 1.19.87 2.34.99 2.5.12.17 1.75 2.67 4.23 3.74.59.26.105.42 1.58.36.64-.03 1.96-.8 2.24-1.57.28-.78.28-1.45.2-1.57-.08-.14-.23-.2-.48-.32l.01.01z" />
	</svg>
);

const WhatsappFloatButton = () => {
	const { t } = useTranslation();
	const inquiryMessage = t(
		'mainLayout.whatsapp.inquiryMessage',
		'Hola, estoy interesado en conocer más sobre sus servicios.'
	);
	const openWhatsApp = () => {
		const phoneNumber = '+17869277710';
		const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(inquiryMessage)}`;
		window.open(url, '_blank');
		gtmUtils.pushDataLayerGTM(GTM_EVENTS.WHATSAPP_FLOAT_CLICK);
	};

	return (
		<div className={styles.container}>
			<button
				id="whatsapp_float_button"
				type="button"
				className={styles.button}
				onClick={openWhatsApp}
				aria-label="Contactar por WhatsApp"
				data-testid="whatsapp-float-button"
			>
				<WhatsappIcon />
			</button>
		</div>
	);
};

export default WhatsappFloatButton;
